import type {
  CoreClientProgramsReadParams,
  CoreCoachProgramsCreateParams,
  CoreCoachProgramsDeleteParams,
  CoreCoachProgramsReadParams,
  CoreCoachProgramsResignParams,
  CoreCoachProgramsSignParams,
  CoreCoachProgramsUpdateParams,
  CorePublicProgramsReadParams,
} from '../types/core/methods';
import type {ProgramApiModel} from './types';

import {EntityStore} from '../utils/entityStore';

export class ProgramStore<
  T extends ProgramApiModel = ProgramApiModel,
> extends EntityStore<
  T,
  object,
  CoreCoachProgramsCreateParams,
  CoreCoachProgramsUpdateParams,
  CoreCoachProgramsDeleteParams
> {
  client = new EntityStore<T, CoreClientProgramsReadParams>('program', {
    fetch: 'client.programs.read',
  });
  coach = new EntityStore<T, CoreCoachProgramsReadParams>('program', {
    fetch: 'coach.programs.read',
  });
  public = new EntityStore<T, CorePublicProgramsReadParams>('program', {
    fetch: 'public.programs.read',
  });
  resign = this._createMethod<CoreCoachProgramsResignParams>({
    method: 'coach.programs.resign',
  });
  sign = this._createMethod<CoreCoachProgramsSignParams>({
    method: 'coach.programs.sign',
  });
}

export const programStore = new ProgramStore('program', {
  create: 'coach.programs.create',
  delete: 'coach.programs.delete',
  update: 'coach.programs.update',
});
